import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveImageCommand extends CommandBase {
    id: string;
    archive: boolean;

    // archive=true (default) records {fileName, key} in the archive so the
    // file stays recoverable from the Archive tab; archive=false is the
    // permanent variant (the data forgets the file entirely).
    constructor(id: string, archive: boolean = true) {
        super();
        this.id = id;
        this.archive = archive;
    }

    execute(data: RemoteConstantsModel): boolean {
        if (this.archive) {
            for (const key of Object.keys(data.images)) {
                if (key === this.id) {
                    const fileName = data.images[key].fileName;
                    data.archive.push({
                        fileName: fileName,
                        key: key
                    });
                }
            }
        }

        delete data.images[this.id];
        return true;
    }
}